import React, { useState, useEffect } from "react";
import "../styles.css";
import StarRating from "./UserPatientScreen/StarRating";
import Modal from "./UserCalendarScreen/CalendarMainModal";
import PromptModal from "./ReuseComponent/PromptModal";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
const CareServiceProfile = ({
  setSelectedSection,
  selectedCareService,
  loggedIn,
}) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);
  const location = useLocation(); // Curent user location for react router dom.
  const queryParams = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();
  const [service, setService] = useState(location.state?.data || null);
  const [loading, setLoading] = useState(!location.state?.data);
  const imgIndex = location.state?.imgIndex || 1;

  const toggleIsRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  // Conditianlly changes the image (direction) for the arrow in the component.
  const profileArrowButton = (e) => {
    const clickedElementId = e.target.getAttribute("id");

    document.getElementById(clickedElementId).classList.toggle("arrowUp");
    document.getElementById(clickedElementId + "Text").classList.toggle("show");
  };

  const moveToLoginPage = () => {
    navigate("/login");
  };

  useEffect(() => {
    // Nếu đã có dữ liệu rồi thì không làm gì cả
    if (service) return;

    const idFromUrl = searchParams.get("id");

    const fetchData = async () => {
      if (idFromUrl) {
        setLoading(true);

        // --- SỬA ĐOẠN NÀY: Dùng axiosReqConfig ---
        // Gọi API lấy danh sách services
        const result = await axiosReqConfig(`${API_IP}/api/services`, "get");

        if (result && Array.isArray(result)) {
          // Tìm service có id trùng khớp trong mảng trả về
          // Lưu ý: id từ URL là string, id trong DB có thể là number, nên dùng == để so sánh lỏng
          const foundService = result.find(
            (s) => s.care_service_id == idFromUrl,
          );

          if (foundService) {
            setService(foundService);
          } else {
            navigate("/UserHome", { replace: true });
          }
        } else {
          // Lỗi hoặc không lấy được data
          navigate("/UserHome", { replace: true });
        }
        // -----------------------------------------

        setLoading(false);
      } else {
        // Không có ID trên URL -> Về trang chủ
        navigate("/UserHome", { replace: true });
      }
    };

    fetchData();
  }, [service, searchParams, navigate]);

  if (loading || !service) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
      >
        <h2>Loading Service...</h2>
      </div>
    );
  }

  return (
    <>
      {service != null ? (
        <div className="padding3-8">
          {loggedIn ? (
            <Modal
              showModal={showModal}
              handleClose={closeModal}
              preSelectedService={service}
              toggleRefresh={toggleIsRefresh}
              setSelectedSection={setSelectedSection}
            />
          ) : (
            <PromptModal
              title={
                "You need to login in order to book an appointment. Go to login page?"
              }
              type={"binary"}
              showModal={showModal}
              handleClose={closeModal}
              handleConsent={moveToLoginPage}
            />
          )}

          <div className="profileCard">
            <div className="profileImage-service">
              <img
                src={require(`../images/care_service_${imgIndex}.png`)}
                className="care-provider-profile-img"
              />
            </div>

            <div className="profileInfo">
              <div className="nameTitle">
                <h1 className="textBlack">{service.care_service_name}</h1>
              </div>

              <div className="eduExperienceContainer">
                <div className="educationContainer">
                  <h5>Location: Victoria</h5>
                </div>
                <div className="educationContainer">
                  <h5>Average Hourly Rate: ${service.hourly_rate}</h5>
                </div>
                <div className="educationContainer">
                  <h5>Minimum Hours: {service.min_hours}h</h5>
                </div>
                {/* <div className="experienceContainer">
                  <h5>Number Of Providers</h5>
                  <h5 className="textBlack textWeight300">5+ Provider</h5>
                </div> */}
              </div>
              <div>
                <h5>Description</h5>
                <p id="profileBioToggleText">
                  {service.description ||
                    "No description available for this service."}
                </p>
              </div>
              <div className="scheduleButtonsContainer">
                <button
                  className="button scheduleAppointmentButton marginLeft"
                  onClick={openModal}
                >
                  Schedule {service.care_service_name}
                </button>
              </div>
            </div>
          </div>
          <div className="careServiceProfileTitleContainer">
            <h1>This service includes</h1>
          </div>
          <div className="subServiceProfileContainer">
            {service.sub_services.map((subService, index) => {
              return (
                <div className="subServiceItem" key={index}>
                  <div className="subServiceItemNumber">
                    <p>{index + 1}</p>
                  </div>
                  <div className="subServiceItemTitle">
                    <p>{subService.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="careServiceProfileNoteContainer">
            <p className="ContactUSNoteText">
              {service.care_service_name} are non-medical in nature. iCare
              Village caregivers do not provide medical treatment, clinical
              assessments, or medication administration.
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CareServiceProfile;
